import texts from './statistics.texts'

class StatisticsController {
    constructor($scope, $timeout) {
        this.name = 'Statistics'

        this.$scope = $scope
        this.timeout = $timeout

        this.activeIndex = 0
        this.isScrolling = false
        this.colors = ['#ea5967', '#475cab', '#f4b460', '#63c19d']
    }

    $onInit() {
        this.render()

        this.bindScroll()

        this.watchLanguage()
    }

    render() {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        const {
            TITLES,
            POLICIES
        } = texts[this.language]

        this.titles = TITLES
        this.policies = POLICIES
    }

    bindScroll() {
        angular.element(document.getElementById('statistics')).bind('mousewheel DOMMouseScroll', (e) => {
            if (this.isScrolling) {
                return
            }

            if (e.originalEvent.wheelDelta < 0) {
                this.scrollDown()
            } else {
                this.scrollUp()
            }
        })
    }

    scrollUp() {
        const height = $(`#slide-${this.activeIndex}`).height()
        const index = this.activeIndex

        if (index === 0) {
            this.isScrolling = false
            return
        }

        if (this.isScrolling) {
            return
        }

        this.isScrolling = true
        this.activeIndex--

            if (this.scrollTimeout) {
                this.timeout.cancel(this.scrollTimeout)
            }

        const activeTag = $(`#slide-${index}`)
        const nextTag = $(`#slide-${index - 1}`)
        const textTag = $('#parallax-text')

        activeTag.css({
            'z-index': 10
        })
        nextTag.css({
            'z-index': 11
        })

        activeTag.animate({
            top: `+=${height}px`
        }, 1000)

        nextTag.animate({
            top: `+=${height}px`
        }, 700)

        textTag.css({
            'background-color': this.colors[index - 1]
        }, 1000)

        this.scrollTimeout = this.timeout(() => {
            this.isScrolling = false
        }, 1000)
    }

    scrollDown() {
        const height = $(`#slide-${this.activeIndex}`).height()
        const index = this.activeIndex

        if (index >= 3) {
            this.isScrolling = false
            return
        }

        if (this.isScrolling) {
            return
        }

        this.isScrolling = true
        this.activeIndex++

            if (this.scrollTimeout) {
                this.timeout.cancel(this.scrollTimeout)
            }

        const activeTag = $(`#slide-${index}`)
        const nextTag = $(`#slide-${index + 1}`)
        const textTag = $('#parallax-text')

        activeTag.css({
            'z-index': 10
        })
        nextTag.css({
            'z-index': 11
        })

        activeTag.animate({
            top: `-=${height}px`
        }, 1000)

        nextTag.animate({
            top: `-=${height}px`
        }, 700)

        textTag.css({
            'background-color': this.colors[index + 1]
        }, 1000)

        this.scrollTimeout = this.timeout(() => {
            this.isScrolling = false
        }, 1000)
    }

    watchLanguage() {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }
}

StatisticsController.$inject = ['$scope', '$timeout']

export default StatisticsController



// WEBPACK FOOTER //
// ./client/app/components/statistics/statistics.controller.js